<script setup>
import Label from "@/components/ui/label/Label.vue";
import Switch from "@/components/ui/switch/Switch.vue";
import { isDarkMode } from "@/darkmode.js";
import { SunMoonIcon } from "lucide-vue-next";
</script>

<template>
  <div class="w-full">
    <table class="w-full">
      <tbody>
        <tr class="h-12">
          <td class="w-12">
            <div class="flex justify-center items-center h-full">
              <SunMoonIcon class="w-6 h-6" />
            </div>
          </td>
          <td>
            <Label for="dark-mode"> Dark Mode </Label>
          </td>
          <td class="w-12">
            <Switch
              id="dark-mode"
              :modelValue="isDarkMode"
              @update:modelValue="
                (value) =>
                  $emit('onDarkModeChange', {
                    state: value ? 'checked' : 'unchecked',
                  })
              "
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
